import { BULK_COMPLETE_TASKS, TASK_ASSIGNMENT, TASKS_FILTER_STATE, TASKS } from "../actions-index";
import { ACTION_STATUS } from "../util/constants";

export function tasks(state = {}, action = {}) {
    const { payload = {}, type } = action;
    switch(type) {
        case TASKS: {
            return payload;
        }
        case TASK_ASSIGNMENT: {
            const { assignee, status, wfId } = payload;
            if(status === ACTION_STATUS.SUCCESS) {
                return { ...state, data: state.data.map((task) => {
                    return ((task.wfId === wfId) ? { ...task, assignee } : task);
                })};
            }
            return state;
        }
        default:
            return state;
    }
}

export function taskAssignment(state = {}, action = {}) {
    const { payload = {}, type } = action;
    if(type === TASK_ASSIGNMENT) {
        const { wfId } = payload;
        if(wfId) {
            return { ...state, [wfId]: payload };
        } else {
            return payload;
        }
    }
    return state;
}

export function tasksFilterState(state = {}, action = {}) {
    return (action.type === TASKS_FILTER_STATE ? action.payload : state);
}

export function bulkCompleteTasks(state = {}, action = {}) {
    return (action.type === BULK_COMPLETE_TASKS ? action.payload : state);
}